<template>
  <div class="MultichoicePopup" :class="{ hasSelectedOption: Boolean(selectedOption) }">
    <StartPane v-bind="{ content, hidePopup, selectOption }" class="startPane" />
    <OptionPane v-bind="{ content, goBack, hidePopup, selectedOption }" class="optionPane" />
  </div>
</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import OptionPane from './OptionPane.vue'
import StartPane from './StartPane.vue'

export default {
  components: {
    StartPane,
    OptionPane,
  },
  inject: ['locale'],
  props: {
    content: Object,
    hidePopup: Function,
    ctaClicked: Function,
    setIsFullHeight: Function,
  },
  data() {
    return {
      selectedOption: null,
    }
  },
  methods: {
    goBack() {
      this.selectedOption = null
      this.setIsFullHeight?.(false)
    },
    selectOption(selectedOption, ctaText) {
      this.selectedOption = selectedOption
      this.setIsFullHeight?.(true)
      pushAnalyticsEvent({
        scope: 'multichoicePromoPopup',
        action: 'ctaClicked',
        content: {
          prompt: this.content.prompt,
          ctaText,
        },
      })
    },
  },
}
</script>

<style scoped>

.MultichoicePopup {
  display: grid;
  overflow-x: hidden;
  align-items: end;
}

.MultichoicePopup > * {
  grid-row: 1;
  grid-column: 1;
}

.startPane {
  display: block;
  opacity: 1;
  transition: opacity 0.25s;
}

.optionPane {
  position: relative;
  left: 100%;
  transition: left 0.25s;
}

.hasSelectedOption .startPane {
  opacity: 0;
}

.hasSelectedOption .optionPane {
  left: 0;
}

@media (--screen-lg) {

  .optionPane {
    left: 0;
    display: none;
  }

  .hasSelectedOption .optionPane {
    display: block;
  }

  .hasSelectedOption .startPane {
    display: none;
  }
}
</style>
